export const snapValue = (value: number, step: number) => {
  if (!step || Number.isNaN(step)) return value;
  return Math.round(value / step) * step;
};

export const snapPoint = (point: { x: number; y: number }, step: number) => ({
  x: snapValue(point.x, step),
  y: snapValue(point.y, step),
});
